import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import VueResource from 'vue-resource'
import vueHeadful from 'vue-headful'
import VueTheMask from 'vue-the-mask'
import ru from 'vee-validate/dist/locale/ru'
import App from './App.vue'
import routes from './routes'
import VueRouter from 'vue-router'
import Touchspin from './components/Touchspin'
import InputDate from './components/InputDate'
import DropDown from './components/DropDown'
import ProjectSelect from './components/ProjectSelect'
import ComplexFilter from './components/ComplexFilter'
import PopupWindow from './components/PopupWindow'
import SearchFilter from './components/SearchFilter'
import Chart from './components/Chart'
import SlideDown from './components/SlideDown'
import FaqComponent from './components/FaqComponent'
import FirstLaunch from './components/FirstLaunch'
import DomainFolder from './components/DomainFolder'
import './helpers/filters'
import './helpers/directives'
import authMixin from './helpers/auth-mixin'
import commonMixin from './helpers/common-mixin'
import './helpers/custom-validators'
import vOutsideEvents from 'vue-outside-events'
import InputTime from './components/InputTime'
import BaseCounter from './components/BaseCounter'
import PdfViewer from './components/PdfViewer'
import VideoViewer from './components/VideoViewer'
import PresentationViewer from './components/PresentationViewer'
import ScormViewer from './components/ScormViewer'
import FroalaEditor from './components/FroalaEditor'
import CheckedDown from './components/CheckedDown'
import DropZone from './components/DropZone'
import ImageSetting from './components/ImageSetting'
import Notification from './components/Notification'


import '../css/style.css'
import '../../node_modules/toastr/build/toastr.css'
import './assets/Bootstrap/bootstrapdatepicker3.min.css'
import './assets/LightBox/style.css'
import './assets/BootstrapTimepicker/bootstrap-timepicker.min.css'


Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueTheMask);
Vue.use(vOutsideEvents);
Vue.use(VeeValidate);


Validator.localize('ru', ru);
Validator.localize({
    ru:{
        messages:{
            confirmed: (e) =>{
                return `Поле «${e}» не совпадает`;
            },
            required: (e) =>{
                return `Поле «${e}» обязательно для заполнения`;
            },
            bik: (e) =>{
                return `Поле «${e}» заполнено не верно`;
            },
            cs: (e) =>{
                return `Поле «${e}» заполнено не верно`;
            },
            rs: (e) =>{
                return `Поле «${e}» заполнено не верно`;
            },
            jsonArray: (e) => {
                return `Поле «${e}» имеет не верный формат для типа Список`;
            },
            lonlat: (e) => {
                return `Поле «${e}» имеет не верный формат`;
            },
            passportSeries: (e, args) => {
                if(args.length > 0 && args[0] === 2) {
                    return `Серия паспорта должна состоять из 2 цифр`;
                } else {
                    return `Серия паспорта должна состоять из 4 цифр`;
                }
            },
            passportNumber: (e, args) => {
                if(args.length > 0 && args[0] === 7) {
                    return `Номер паспорта должен состоять из 7 цифр`;
                } else {
                    return `Номер паспорта должен состоять из 6 цифр`;
                }
            },
            innfl: (e) => {
                return `ИНН физического лица должен состоять из 12 цифр`;
            }
        }
    }
});


Vue.component('vue-headful', vueHeadful);
Vue.component('touch-spin', Touchspin);
Vue.component('input-date', InputDate);
Vue.component('drop-down', DropDown);
Vue.component('project-select', ProjectSelect);
Vue.component('complex-filter', ComplexFilter);
Vue.component('popup-window', PopupWindow);
Vue.component('search-filter', SearchFilter);
Vue.component('chart', Chart);
Vue.component('slide-down', SlideDown);
Vue.component('faq-component', FaqComponent);
Vue.component('first-launch', FirstLaunch);
Vue.component('domain-folder', DomainFolder);
Vue.component('input-time', InputTime);
Vue.component('base-counter', BaseCounter);
Vue.component('pdf-viewer', PdfViewer);
Vue.component('video-viewer', VideoViewer);
Vue.component('presentation-viewer', PresentationViewer);
Vue.component('scorm-viewer', ScormViewer);
Vue.component('froala-editor', FroalaEditor);
Vue.component('checked-down', CheckedDown);
Vue.component('drop-zone', DropZone);
Vue.component('image-setting', ImageSetting);
Vue.component('notification', Notification);


Vue.mixin(authMixin);
Vue.mixin(commonMixin);

const router = new VueRouter({
    routes: routes,
    mode: 'history'
});

new Vue({
    el: '#root',
    router,
    render: h => h(App)
});

/*для отображения SVG*/
(function () {
    if ("undefined" !== typeof window && window.addEventListener) {
        var e = Object.create(null), l, d = function () { clearTimeout(l); l = setTimeout(n, 100); }, m = function () { }, t = function () {
            window.addEventListener("resize", d, !1); window.addEventListener("orientationchange", d, !1); if (window.MutationObserver) {
                var k = new MutationObserver(d); k.observe(document.documentElement, { childList: !0, subtree: !0, attributes: !0 }); m = function () {
                    try {
                        k.disconnect(), window.removeEventListener("resize", d, !1), window.removeEventListener("orientationchange", d, !1);
                    } catch (v) { console.log('error svg'); }
                };
            } else document.documentElement.addEventListener("DOMSubtreeModified", d, !1), m = function () { document.documentElement.removeEventListener("DOMSubtreeModified", d, !1); window.removeEventListener("resize", d, !1); window.removeEventListener("orientationchange", d, !1); };
        }, u = function (k) {
            function e(a) { if (void 0 !== a.protocol) var c = a; else c = document.createElement("a"), c.href = a; return c.protocol.replace(/:/g, "") + c.host; } if (window.XMLHttpRequest) {
                var d = new XMLHttpRequest; var m = e(location); k = e(k); d = void 0 ===
                    d.withCredentials && "" !== k && k !== m ? XDomainRequest || void 0 : XMLHttpRequest;
            } return d;
        }; var n = function () {
            function d() { --q; 0 === q && (m(), t()); } function l(a) { return function () { !0 !== e[a.base] && (a.useEl.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#" + a.hash), a.useEl.hasAttribute("href") && a.useEl.setAttribute("href", "#" + a.hash)); }; } function p(a) {
                return function () {
                    var c = document.body, b = document.createElement("x"); a.onload = null; b.innerHTML = a.responseText; if (b = b.getElementsByTagName("svg")[0]) b.setAttribute("aria-hidden",
                        "true"), b.style.position = "absolute", b.style.width = 0, b.style.height = 0, b.style.overflow = "hidden", c.insertBefore(b, c.firstChild); d();
                };
            } function n(a) { return function () { a.onerror = null; a.ontimeout = null; d(); }; } var a, c, q = 0; m(); var f = document.getElementsByTagName("use"); for (c = 0; c < f.length; c += 1) {
                try { var g = f[c].getBoundingClientRect(); } catch (w) { g = !1; } var h = (a = f[c].getAttribute("href") || f[c].getAttributeNS("http://www.w3.org/1999/xlink", "href") || f[c].getAttribute("xlink:href")) && a.split ? a.split("#") : ["", ""]; var b =
                    h[0]; h = h[1]; var r = g && 0 === g.left && 0 === g.right && 0 === g.top && 0 === g.bottom; g && 0 === g.width && 0 === g.height && !r ? (f[c].hasAttribute("href") && f[c].setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", a), b.length && (a = e[b], !0 !== a && setTimeout(l({ useEl: f[c], base: b, hash: h }), 0), void 0 === a && (h = u(b), void 0 !== h && (a = new h, e[b] = a, a.onload = p(a), a.onerror = n(a), a.ontimeout = n(a), a.open("GET", b), a.send(), q += 1)))) : r ? b.length && e[b] && setTimeout(l({ useEl: f[c], base: b, hash: h }), 0) : void 0 === e[b] ? e[b] = !0 : e[b].onload && (e[b].abort(),
                        delete e[b].onload, e[b] = !0);
            } f = ""; q += 1; d();
        }; var p = function () { window.removeEventListener("load", p, !1); l = setTimeout(n, 0); }; "complete" !== document.readyState ? window.addEventListener("load", p, !1) : p();
    }
})();



// WEBPACK FOOTER //
// ./Content/src/main.js